import { useQuery } from '@tanstack/react-query';
import { getRescanComparison } from '../utils/rescanApi';
import type { RescanComparison } from '../types';

export const rescanCompareKey = (companyId: number | null | undefined) =>
  ['th', 'rescan', 'compare', companyId] as const;

export const useRescanCompare = (companyId: number | null | undefined, scanId?: number | null) => {
  return useQuery<RescanComparison | null>({
    queryKey: [...rescanCompareKey(companyId), scanId ?? 'latest'],
    queryFn: () => getRescanComparison(companyId as number, scanId),
    enabled: !!companyId,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
